/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getSampleAnnotation, setAnnotedSampleImage } from '../store/DevelopmentOrder.action';
import { fetchTrafficLights } from '../Bom/store/BOMConfig.action';
import SampleSupplierAnnotation from '../../../Components/Utility/Annotation/SampleSupplierAnnotation';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import Loader from '../../../Components/Utility/Loader/Loader';

function SupplierImageAnnotation({ getSampleAnnotation, fetchTrafficLights, SampleAnnotationData, setAnnotedSampleImage, match }) {
  const { t } = useTranslation('common');

  /* useState */
  const [obj1Confirm, setObj1Confirm] = useState({});
  const [updateURLConfirm, setUpdateURLConfirm] = useState('');

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [count, setCount] = useState(-1);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [updateData, setUpdateData] = useState(true);

  const [currentImage, setCurrentImage] = useState({
    annotedImage: '',
    name: '',
    image: '',
    originalImage: '',
    isNewItem: null,
    _id: '',
    markerObj: {},
  });

  const devOrderID = match?.params?.devOrderId || match?.devOrderId;
  const sampleId = match?.params?.sampleId || match?.sampleId;

  const { search } = window.location;
  const params = new URLSearchParams(search);
  const imagePath = params?.get('imgName');

  const initialExicution = async () => {
    await fetchTrafficLights(devOrderID);
    await getSampleAnnotation(devOrderID, sampleId, 'supplierAnnotation');
    setLoader(false);
  };

  useEffect(() => {
    initialExicution();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (SampleAnnotationData?.length) {
      setTotalCount(SampleAnnotationData.length - 1);
      const result = SampleAnnotationData.find((elem) => elem?._id === imagePath);
      if (result) {
        setCurrentImage({
          annotedImage: result.annotedImage ? result.annotedImage : result.image,
          markerObj: result.markerObj ? result.markerObj : {},
          name: result.name,
          _id: result._id,
          image: result.image,
          originalImage: result.originalImage ?? result.image,
          isNewItem: result?.isNewItem,
        });

        const index = count >= 0 ? count : SampleAnnotationData.findIndex((x) => x._id === imagePath);

        setCount(index);
      }
    }
  }, [SampleAnnotationData]);

  useEffect(() => {
    if (SampleAnnotationData?.length) {
      const result = SampleAnnotationData.find((elem, i) => count === i);
      if (result) {
        setCurrentImage({
          annotedImage: result.annotedImage ? result.annotedImage : result.image,
          markerObj: result.markerObj ? result.markerObj : {},
          name: result.name,
          _id: result._id,
          image: result.image,
          originalImage: result.originalImage ?? result.image,
          isNewItem: result?.isNewItem,
        });
      }
    }
  }, [count, updateData]);

  const onEditModeOn = async (val) => {
    setIsEditOpen(val);
  };

  const onSave = async (obj, newObj, updatedUrl) => {
    if (!currentImage.isNewItem) {
      setObj1Confirm(obj);
      setUpdateURLConfirm(updatedUrl);
      setShowConfirmationPopup(true);
    } else {
      saveAnnotation(obj, newObj, updatedUrl);
    }
  };

  const saveAnnotation = async (obj1, obj2, updateURL) => {
    // Post Api For data in Database
    if (JSON.stringify(obj1.markers) !== JSON.stringify(obj2.markers)) {
      setLoader(true);
      const postParams = {
        design: {
          name: currentImage.name,
          annotedImage: updateURL,
          image: currentImage.originalImage,
          isNewItem: true,
          _id: currentImage._id,
          markerObj: obj1,
        },
        isSupplierAnnotation: true,
      };
      const result = await setAnnotedSampleImage(devOrderID, sampleId, postParams, t);
      if (result) {
        await getSampleAnnotation(devOrderID, sampleId, 'supplierAnnotation');
        setUpdateData(!updateData);
      }
      setLoader(false);
      setObj1Confirm({});
      setUpdateURLConfirm('');
      setConfirmLoader(false);
    }
  };

  const handleNext = () => {
    setCount(count + 1);
  };

  const handlePrevious = () => {
    setCount(count - 1);
  };

  const sampleImgSet = () => {
    return currentImage.isNewItem === true ? currentImage.annotedImage : currentImage.image;
  };

  const annotationCalled = () => {
    return currentImage.image ? (
      <SampleSupplierAnnotation
        sampleImage={sampleImgSet()}
        sourceImage={currentImage.image}
        markerObj={currentImage.markerObj}
        onSaveAnnotation={onSave}
        setIsEditOpen={onEditModeOn}
      />
    ) : (
      <div className="text-center pt-50per">{t('DEVLOPMENT_ORDER.SUPLIER_IMAGE_ANNOTATION.NO_IMAGE_FOUND')}</div>
    );
  };
  const closeConfirmationsPopup = () => {
    setShowConfirmationPopup(false);
    setConfirmLoader(false);
    setObj1Confirm({});
    setUpdateURLConfirm('');
  };

  const confirmRemoveOldData = () => {
    setConfirmLoader(true);
    saveAnnotation(obj1Confirm, {}, updateURLConfirm);
    setShowConfirmationPopup(false);
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">{t('DEVLOPMENT_ORDER.SUPLIER_IMAGE_ANNOTATION.SAMPLES')}</h4>&nbsp;
          {currentImage?.name !== '' && (
            <div className="referance-code">
              <span className="ng-binding">|&nbsp;{currentImage?.name}</span>
            </div>
          )}
        </div>
        <div className="ml-auto">
          <Link className="btn p-0 d-inline-flex" to={`/development-order/${devOrderID}/samples-details/annotateImages?sample=${sampleId}`}>
            <span className="icon-close f-20" />
          </Link>
        </div>
      </div>
      {loader ? (
        <Loader />
      ) : (
        <div className="container-fluid">
          <div className="row justify-content-center pt-3" style={{ marginBottom: '50px' }}>
            <div className="col-lg-11">
              {annotationCalled()}
              <button className="btn-marker-nav next" onClick={handleNext} disabled={count === totalCount || isEditOpen}>
                <span className="iconify" data-icon="grommet-icons:next" />
              </button>
              <button className="btn-marker-nav prev" onClick={handlePrevious} disabled={count === 0 || isEditOpen}>
                <span className="iconify" data-icon="grommet-icons:previous" />
              </button>
            </div>
          </div>
        </div>
      )}
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={() => confirmRemoveOldData()}
          title={t('DEVLOPMENT_ORDER.SUPLIER_IMAGE_ANNOTATION.CONFIRM_ACTION')}
          message={t('DEVLOPMENT_ORDER.SUPLIER_IMAGE_ANNOTATION.ANNOTION_MESSAGE')}
          toggle={closeConfirmationsPopup}
          loading={confirmLoader}
        />
      )}
    </>
  );
}

const mapStateToProps = ({ Measuremets }) => {
  const { SampleAnnotationData } = Measuremets;
  return { SampleAnnotationData };
};

const mapStateToDispatch = {
  getSampleAnnotation,
  fetchTrafficLights,
  setAnnotedSampleImage,
};

export default connect(mapStateToProps, mapStateToDispatch)(SupplierImageAnnotation);
